import React from "react";
import { ChevronDown, ChevronUp, RefreshCw, Loader } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };
const SERIF = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

function FieldLabel({ children }) {
  return (
    <label className="block text-xs uppercase tracking-widest text-[#8B5E34] mb-1.5" style={LORA}>
      {children}
    </label>
  );
}

export function EditorDayItem({ day, dayIdx, openDay, setOpenDay, setDayField, regenerateDay, regenDay }) {
  const isOpen = openDay === dayIdx;

  return (
    <div
      className="border border-[#DCD4C6]"
      style={{ borderRadius: "2px" }}
      data-testid={`editor-day-${dayIdx}`}
    >
      {/* Day header */}
      <button
        className="w-full flex items-center justify-between px-4 py-3 text-left transition-colors hover:bg-[#F1EBE1]"
        style={{ background: isOpen ? "#F1EBE1" : "transparent" }}
        onClick={() => setOpenDay(isOpen ? -1 : dayIdx)}
        data-testid={`editor-day-toggle-${dayIdx}`}
      >
        <div className="flex items-center gap-3 min-w-0">
          <span
            className="text-xs text-[#C17F59] font-semibold uppercase tracking-widest flex-shrink-0"
            style={LORA}
          >
            {day.jour}
          </span>
          <span
            className="text-sm text-[#2B2623] truncate"
            style={{ ...SERIF, fontWeight: 600 }}
          >
            {day.titre}
          </span>
        </div>
        {isOpen ? (
          <ChevronUp size={14} strokeWidth={2} className="text-[#9A8F86] flex-shrink-0 ml-2" />
        ) : (
          <ChevronDown size={14} strokeWidth={2} className="text-[#9A8F86] flex-shrink-0 ml-2" />
        )}
      </button>

      {/* Day fields */}
      {isOpen && (
        <div className="px-4 pb-4 pt-3 space-y-3 border-t border-[#DCD4C6] bg-white">
          <div className="flex justify-end">
            <button
              onClick={() => regenerateDay(dayIdx)}
              disabled={regenDay !== null}
              className="flex items-center gap-1.5 px-3 py-1.5 text-xs border border-[#C17F59]/40 text-[#C17F59] hover:bg-[#C17F59]/10 disabled:opacity-40 transition-colors"
              style={{ ...LORA, borderRadius: "2px" }}
              data-testid={`editor-day-${dayIdx}-regen-btn`}
              title="Demander à Claude de réécrire ce jour"
            >
              {regenDay === dayIdx ? (
                <Loader size={12} strokeWidth={1.5} className="animate-spin" />
              ) : (
                <RefreshCw size={12} strokeWidth={1.5} />
              )}
              {regenDay === dayIdx ? "Régénération..." : "Régénérer ce jour"}
            </button>
          </div>
          <div>
            <FieldLabel>Titre de la journée</FieldLabel>
            <input
              className="w-full border border-[#DCD4C6] px-3 py-2 text-sm text-[#2B2623] focus:outline-none focus:border-[#C17F59] transition-colors"
              style={{ ...LORA, borderRadius: "2px" }}
              value={day.titre || ""}
              onChange={(e) => setDayField(dayIdx, "titre", e.target.value)}
              data-testid={`editor-day-${dayIdx}-titre`}
            />
          </div>
          <div>
            <FieldLabel>Description de la journée</FieldLabel>
            <textarea
              className="w-full border border-[#DCD4C6] px-3 py-2 text-sm text-[#2B2623] resize-y focus:outline-none focus:border-[#C17F59] transition-colors"
              style={{ ...LORA, borderRadius: "2px" }}
              rows={5}
              value={day.description || ""}
              onChange={(e) => setDayField(dayIdx, "description", e.target.value)}
              data-testid={`editor-day-${dayIdx}-description`}
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <FieldLabel>Hôtel / Hébergement suggéré</FieldLabel>
              <input
                className="w-full border border-[#DCD4C6] px-3 py-2 text-sm text-[#2B2623] focus:outline-none focus:border-[#C17F59] transition-colors"
                style={{ ...LORA, borderRadius: "2px" }}
                value={day.hebergement_suggere || ""}
                onChange={(e) => setDayField(dayIdx, "hebergement_suggere", e.target.value)}
                data-testid={`editor-day-${dayIdx}-hebergement`}
              />
            </div>
            <div>
              <FieldLabel>Repas suggérés</FieldLabel>
              <input
                className="w-full border border-[#DCD4C6] px-3 py-2 text-sm text-[#2B2623] focus:outline-none focus:border-[#C17F59] transition-colors"
                style={{ ...LORA, borderRadius: "2px" }}
                value={day.repas_suggeres || ""}
                onChange={(e) => setDayField(dayIdx, "repas_suggeres", e.target.value)}
                data-testid={`editor-day-${dayIdx}-repas`}
              />
            </div>
          </div>
          <div>
            <FieldLabel>Budget du jour (estimation par personne)</FieldLabel>
            <input
              className="w-full border border-[#DCD4C6] px-3 py-2 text-sm text-[#2B2623] focus:outline-none focus:border-[#C17F59] transition-colors"
              style={{ ...LORA, borderRadius: "2px" }}
              value={day.budget_jour || ""}
              onChange={(e) => setDayField(dayIdx, "budget_jour", e.target.value)}
              data-testid={`editor-day-${dayIdx}-budget`}
            />
          </div>
        </div>
      )}
    </div>
  );
}
